import { GridModel } from "common/models/utility-models/list-utility.model";
import { ResultReportsModel } from "./result-reports-data.model";

export class ResultReportsGridModel extends ResultReportsModel { }

export class ResultReportsListingModel extends GridModel<ResultReportsGridModel> {
  
}